<!-- Content -->
<div class="content">
  <mat-card>
    <mat-card-content>
        <!-- Title -->
        <h1>Profile</h1>

        <!-- Profile -->
        <div class="field username">
          <div class="label">Username</div>
          <div class="value" data-cy="username">{{ username | titlecase }}</div>
        </div>

        <div class="field roles" style="display: none;">
          <div class="label">Roles</div>
          <div class="value" data-cy="roles">
            <ul>
              <li *ngFor="let role of roles">
                {{role}}
              </li>
            </ul>
          </div>
        </div>

        <!-- Logout -->
        <div class="logout" *ngIf="logoutAvailable">
          <button mat-raised-button color="primary" (click)="logout()" data-cy="logout">Log Out</button>
        </div>
    </mat-card-content>
  </mat-card>

  <app-device-info></app-device-info>
</div>